import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import Table from "../../../components/Table/Table";
import '../Customer.css';
import moment from "moment";

class DistributorInfoModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            content: [],
            loading: false,
            total: 0,
            page: 0,
            size: 10,
            manual: false,
            alert: null,
            note: []
        };

        this.fetchDistributorInfo = this.fetchDistributorInfo.bind(this);
        this.modifyDate = this.modifyDate.bind(this);
    }

    modifyDate(date) {
        return moment(date).format('DD-MM-YYYY HH:mm:ss');
    }

    fetchDistributorInfo(accessor, direction, page, size) {
        let self = this;
        if (!page && page !== 0) {
            if (self.state.page) {
                page = self.state.page;
            } else {
                page = 0;
            }
        }

        if (!size) {
            if (self.state.size) {
                size = self.state.size;
            } else {
                size = 10;
            }
        }
        let url = '/customer/fetchDistributorInfo?page=' + page + '&size=' + size;
        let params = {
            url: url,
            method: "post",
            data: self.props.customer.recordId
        };
        self.setState({loading: true, manual: self.manual === true ? false : self.manual});
        request(params)
            .then(function (response) {
                self.setState({
                    content: response.data.content,
                    manual: false,
                    loading: false,
                    page: page,
                    size: size,
                    total: response.data.totalElements
                });
            }).catch(function (error) {
            showAxiosError(error);
            self.setState({manual: false, loading: false})
        });
    }

    render() {

        let columns = [
            {
                Header: "Değişikliği Yapan Kullanıcı Adı",
                title: "changedUserName",
                accessor: "changedUserName",
                width: "25%",
                sortable: false
            },
            {
                Header: "Değişiklik Tarihi",
                title: "changedAt",
                accessor: "changedAt",
                width: "25%",
                sortable: false,
                Cell: row => (
                    <label>{this.modifyDate(row.changedAt)}</label>
                )
            },
            {
                Header: "Eski Bayi",
                title: "oldCustomerName",
                accessor: "oldCustomerName",
                width: "25%",
                sortable: false
            },
            {
                Header: "Yeni Bayi",
                title: "newCustomerName",
                accessor: "newCustomerName",
                width: "25%",
                sortable: false
            }
        ];

        return (
            <div>
                <Modal isOpen={this.props.isOpen} size='lg'>
                    <ModalHeader toggle={() => this.props.toggle()}>Bayi Bilgileri</ModalHeader>
                    <ModalBody className="mt-1">
                        <div className="col-sm-12 row" style={{right: '-15px'}}>
                            <Table columns={columns}
                                   content={this.state.content}
                                   total={this.state.total}
                                   page={this.state.page}
                                   size={this.state.size}
                                   loading={this.state.loading}
                                   options={["5", "10", "20", "50", "100"]}
                                   fetchData={this.fetchDistributorInfo}
                                   manual={this.state.manual}
                                   paginationEnabled={true}
                            />
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button type="button" onClick={() => this.props.toggle()}
                                style={{
                                    background: ' linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                    padding: '9px 45px 9px 20px'
                                }}
                                className="TekBtn vazgec ml-auto">Kapat
                        </button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}

export default DistributorInfoModal;